import React, { useState, useRef, useEffect } from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useSwipeable } from 'react-swipeable';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './index.css';

const images = [
  'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fpic7.webp?alt=media&token=6d5db0bc-976e-46e7-b5a1-de75e8d1b0c0',
  'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fshared.webp?alt=media&token=e125deba-2d83-4a2f-ad51-da0862c210e6',
  'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla3.webp?alt=media&token=3b5c5d5a-0e15-41a6-9517-cf8752ea47eb',
  'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla6.webp?alt=media&token=c7e45f97-650b-4466-a281-93db0da30864',
  'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla9.webp?alt=media&token=41541a8d-0dbf-4abf-86f8-284675df65ed',
  'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla8.webp?alt=media&token=f22a0cd8-03f2-485e-8221-b0baed029f43'
];

const Gallery = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const thumbnailRefs = useRef([]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (activeIndex < images.length - 1) setActiveIndex(prev => prev + 1);
    },
    onSwipedRight: () => {
      if (activeIndex > 0) setActiveIndex(prev => prev - 1);
    },
    trackMouse: true,
  });

  const handlePrev = () => {
    if (activeIndex > 0) setActiveIndex(prev => prev - 1);
  };

  const handleNext = () => {
    if (activeIndex < images.length - 1) setActiveIndex(prev => prev + 1);
  };

  useEffect(() => {
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, 100); 
}, []);
 
  useEffect(() => {
    if (thumbnailRefs.current[activeIndex]) {
      thumbnailRefs.current[activeIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [activeIndex]);

  return (
    <div className="gallery-container">
      <h2 className='imageHead'>Image Gallery</h2>

      <div className="thumbnail-row">
        {images.map((img, index) => (
          <img
            key={index}
            ref={(el) => (thumbnailRefs.current[index] = el)}
            src={img}
            alt={`Thumbnail ${index + 1}`}
            className={`thumbnail ${activeIndex === index ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>

      <div className="full-image-container" {...swipeHandlers}>
        <div className="image-arrow image-left-arrow" onClick={handlePrev}>
          <FaChevronLeft />
        </div>
        <Zoom>
          <img
            src={images[activeIndex]}
            alt="Full view"
            className="full-image fade-in"
            key={images[activeIndex]}
          />
        </Zoom>
        <div className="image-arrow image-right-arrow" onClick={handleNext}>
          <FaChevronRight />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
